import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AuthState } from '../state';

const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectSessionUser = createSelector(selectAuthState, (authState: AuthState) => authState.sessionUser);
